import { createAction } from 'redux-actions';
import * as actionType from './actionTypes';

export const setSelectedProduct = createAction(actionType.SET_SELECTED_PRODUCT);
export const resetSelectedProduct = createAction(actionType.RESET_SELECTED_PRODUCT);
